import { createUseStyles } from 'react-jss';
import { colors } from '../../constants/colors';
import { breakpoints } from '../../constants/breakpoints';

const styles = createUseStyles((theme) => ({
  leaveCompanyPage: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  largeLogo: {
    marginTop: "96px",
    "& svg": {
      width: "240px",
      height: "96px"
    }
  },
  container: {
    maxWidth: "720px",
    display: 'flex',
    flexDirection: 'column',
    alignItems: "center",
    textAlign: 'center',
    height: '100%',
    margin: "0 auto"
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: "24px",
    margin: "48px 10px",
  },
  title: {
    textAlign: "center",
    fontSize: '60px',
    fontWeight: '600',
    lineHeight: '72px',    
    letterSpacing: "-1.2px",
    color: colors.lightBlack,
    marginBottom: 0,
  },
  description: {
    textAlign: "center",
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '30px',
    color: colors.mediumGrey,
    marginBottom: 0,
  },
  time: {
    textAlign: "center",
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
    color: colors.mediumGrey,
    marginBottom: 0
  },
  lang: {
    display: "flex",
    position: "absolute",
    alignItems: "center",
    alignSelf: "end",
    margin: "32px 64px",
    height: "32px",
    "& :focus:not(.focus-visible)":{
      outline:0,
    },
    "& :focus-visible":{
      boxShadow: "0px 0px 0px 4px " + colors.lightBlue
    },
    "&:hover": {
      cursor: "pointer",
      textColor: theme.navigation.li.active.color,
    },
    "& .langSelector": {
      display: "flex",
      width: "100%",
      textDecoration: "none",
      color: colors.grey,
      borderRadius: "4px",
      "& div": {
        marginLeft: "14px",
        alignSelf: "center",
      },
    },
  },
  popoverStyle:{
    "& .popover-arrow": {
      display: "none !important",
    },
  },
  popoverImage:{
    marginRight:"8px",
    width:"20px",
    height:"20px",
    "& path": {
      stroke: colors.mediumGrey
    }
  },
  overlayLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: colors.mediumGrey,
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    marginLeft:"24px",
    "&:hover": {
      color: colors.grey,
      backgroundColor: colors.brightBlue,
      borderRadius: "8px",
      "& path": {
        stroke: colors.grey
      }
    },
    width: "100%",
  },
  button: {
    width: "fit-content",
    fontSize: "18px",
    fontWeight: "600",
    lineHeight: "28px",
    padding: "16px 28px"
  },
  footer: {
    position: "absolute",
    bottom: "32px",
    display: "flex",
    flexDirection: "row",
    width: "-webkit-fill-available",
    justifyContent: "space-between",
    margin: "auto 80px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "auto 10px",
    }
  },
  copyright: {
    color: colors.inactiveGrey,
    lineHeight: "24px",
    fontSize: "16px",
    fontWeight: "400",
  },
  links: {
    display: "flex",
    flexDirection: "row",
    gap: "16px"
  },
  terms: {
    display: "flex",
    alignItems: "center",
    "& :focus:not(.focus-visible)":{
      outline:"none",
    },

    "& :focus-visible":{
      color: theme.navigation.li.active.color,
    },
    "& :hover": {
      color: theme.navigation.li.active.color,
    },
    "& a": {
      display: "flex",
      width: "100%",
      textDecoration: "none",
      color: colors.inactiveGrey,
      borderRadius: "4px",
      lineHeight: "24px",
      fontSize: "16px",
      fontWeight: "400",
      "& div": {
        alignSelf: "center",
      },
    },
  },
  flagStyle: {
    marginRight: "8px"
  },
}));

export default styles;
